import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { InputTextComponent } from '../../inputs/input-text/input-text.component';

@Component({
  selector: 'app-key-value-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextComponent
  ],
  templateUrl: './key-value-form.component.html',
  styleUrl: './key-value-form.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyValueFormComponent {
  @Input() form!: FormGroup;
  @Input() keyField: string = 'key';
  @Input() valueField: string = 'value';
  @Input() keyValidators: ValidatorFn[] = [Validators.required];
  @Input() valueValidators: ValidatorFn[] = [];
  @Input() keyLabel: string = 'Codice';
  @Input() valueLabel: string = 'Descrizione';

  ngOnInit() {
    this.form.addControl(this.keyField, new FormControl(null, this.keyValidators));
    this.form.addControl(this.valueField, new FormControl(null, this.valueValidators));
  }
}
